import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MyCollapse from 'components/Collapse';
import moment from 'moment';
import { useCallback } from 'react';
import React from 'react';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import { BuyerDetails } from './buyerDetails';
import { ChangePaymentMethod } from './changePaymentMethod';
import FiscalDocument from './fiscalDocument';
import InvoiceDetails from './invoiceDetails';
import { PaymentHistory } from './paymentHistory';
import useStyle from '../styles';

interface JobProductProps {
  delivery: ShoppingDelivery;
  closeQuickView: () => void;
}

const JobProduct = ({ delivery, closeQuickView }: JobProductProps) => {
  const handleClickDownload = useCallback((hash: string | boolean) => {
    window.open('/downloads/' + hash, '_blank');
  }, []);

  const classes = useStyle();

  return (
    <>
      <div className={classes.quickviewDataBasic}>
        <Grid container spacing={2}>
          <Grid item md={4} sm={12} xs={12}>
            <div className='image' style={{ backgroundImage: `url(${delivery.product.image})` }}></div>
          </Grid>

          <Grid item md={8} sm={12} xs={12}>
            <div className='info'>
              <h2>
                {delivery.product.title}
                {delivery.product.physicalDelivery.status && <span className='status'>{delivery.product.physicalDelivery.status}</span>}
              </h2>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className='m24'></div>

      <BuyerDetails delivery={delivery} />

      <div className='m24'></div>

      <div className={classes.sender}>
        <div className='data'>
          <span>Criação:</span> {moment(delivery.createdAt).format('DD/MM/YYYY H:mm')}
        </div>
        <div className='data'>
          <span>Previsão de entrega:</span>{' '}
          {delivery.product.physicalDelivery.expectedDeliveryDate
            ? moment(delivery.product.physicalDelivery.expectedDeliveryDate).format('DD/MM/YYYY H:mm')
            : '-'}
        </div>
        <div className='data'>
          <span>Entrega:</span>{' '}
          {delivery.product.physicalDelivery.deliveryDate ? moment(delivery.product.physicalDelivery.deliveryDate).format('DD/MM/YYYY H:mm') : '-'}
        </div>
      </div>

      <div className='m24'></div>

      <MyCollapse title='Contato com Produtor' arrow>
        <div className={classes.sender}>
          {delivery.producer.name && (
            <div className='data'>
              <span>Nome:</span> {delivery.producer.name}
            </div>
          )}
          {delivery.producer.email && (
            <div className='data'>
              <span>E-mail:</span> {delivery.producer.email}
            </div>
          )}
          {delivery.producer.phone && (
            <div className='data'>
              <span>Telefone:</span> {delivery.producer.phone}
            </div>
          )}
          {delivery.producer.address && (
            <div className='data'>
              <span>Endereço:</span> {delivery.producer.address}
            </div>
          )}
        </div>
      </MyCollapse>

      <div className='m8'></div>

      {!delivery.isUnlimitedInstallments && <InvoiceDetails delivery={delivery} />}

      {delivery.isUnlimitedInstallments && <PaymentHistory delivery={delivery} />}

      <div className='m8'></div>

      <FiscalDocument delivery={delivery} />

      <div className='m8'></div>
      {delivery.product.downloadHash && (
        <Grid item xs={12}>
          <Button color='primary' onClick={() => handleClickDownload(delivery.product.downloadHash)} fullWidth>
            Download Materiais
          </Button>
        </Grid>
      )}
      <div className='m8'></div>

      {delivery.isUnlimitedInstallments && <ChangePaymentMethod delivery={delivery} closeQuickView={closeQuickView} />}
    </>
  );
};

export default JobProduct;
